/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Constants" />

export const ChecksPreviewFeature = "ms.vss-pipelinechecks.checks-ui";

export const EndpointsEditorTypesViewType = "ServiceEndpointTypes";

export const EndpointSchemeConversionSuccessful = "upgrade_successful";
export namespace ViewTypes {
    export const Security = "security";
}

export namespace ServiceEndpointOperationStatus {
    export const InProgress = "InProgress";
    export const Failed = "Failed";
}

export namespace ServiceEntpointFeatureFlags {
    export const EnableStreamlinedScrollEventsInServiceEndpointHistory = "ServiceEndpoints.EnableStreamlinedScrollEventsInServiceEndpointHistory";
    export const AllowDisablingServiceEndpoints = "ServiceEndpoints.AllowDisablingServiceEndpoints";
    export const EnableSecretExpirationBanner = "ServiceEndpoints.EnableSecretExpirationBanner";
}